//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Autocomplete from 'vue2-autocomplete-js';
import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid'; 
import MASTER_MENU from  '../../library/master_menu'
import FETCHING from  '../../library/fetching'



 

export default {
    data () {
        return {
            FETCHING:FETCHING,
            token : localStorage.token,
            terbitkanSurat  :false,
            MASTER_MENU:MASTER_MENU, 
            UMUM:UMUM, 

            page_limit : 10,
            page_first: 1,
            page_last: 0,
            cari_value: "",

 
            option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

            shape: '',  
            dense:true,  
            current: 3, 
            model: '',

            modal_edit_anggota_keluarga:false,
            modal_hapus_keluarga:false,

            modal_y:false,
            modal_n:false,

            lihat_blue:false,
            lihat_red:false,


            modul:'kk3',
            id:'',
            index_ke:'',
            form: {
              id : '',
              KKref : '',
              id_dari_form : '',

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '', 

              permohonan: '',
              permohonan_lainnya: '',
              nama: '',
              nik: '',
              no_kk: '',

              shdk:'',
              shdk_lainnya:'',
              agama : '',
              agama_lainnya : '',
              pekerjaan : '',
              pekerjaan_lainnya : '',
              pendidikan : '',
              pendidikan_lainnya : '',

              alamat: '',
              rt: '',
              rw: '',
              kode_pos: '',
              Telepon: '',
              no_kitap: '',
              tgl_berakhir_kitap: '',

              provinsi: '',
              kabupaten: '',
              kecamatan: '',  
              desa_kelurahan: '',

              file_Kabupaten:null,
              file_Old_Kabupaten:null,


                status : 0,
                keterangan : 0,
                
                keterangan_deskel:'',
                keterangan_kecamatan:'',
                keterangan_kabupaten  :'',

                status_deskel:0,
                status_kecamatan:0,
                status_kabupaten  :0,

                createdBy : '',
                createdAt : '',
                createdAt_deskel:'',
                createdAt_kecamatan:'',
                createdAt_kabupaten  :'',

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',

              file              : null, 
              fileThumb         : null, 
              file_lampiran     : null,
              file_lampiranOld  : null,
              


            },   
            anggota_keluarga: {
                nik : '',
                nama : '',
                tanggal_lahir : '',
                jenis_kelamin : '',
                shdk:'',
                shdk_lainnya:'',
                agama : '',
                agama_lainnya : '',
                pekerjaan : '',
                pekerjaan_lainnya : '',
                pendidikan : '',
                pendidikan_lainnya : '',
            },

            file:'',
            fileOld:'',


            list_anggota_keluarga:[],
            list_data:[],
            list_data_kecamatan:[],
            list_data_kabupaten:[],

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayah_pemohon : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },    

 

        }
    },
    methods: {
 
      addAnggotaKeluarga:function(){
        var arr = this.list_anggota_keluarga; 
        arr.push(this.anggota_keluarga);
        
        this.anggota_keluarga = {
                nik : '',
                nama : '',
                tanggal_lahir : '',
                jenis_kelamin : '',
                status_hubungan_dl_keluarga : '',
                agama : '',
                agama_lainnya : '',
                pekerjaan : '',
                pekerjaan_lainnya : '',
                pendidikan : '',
                pendidikan_lainnya : '', 
        }
      },
      delete_keluarga : function (index){  
        this.list_anggota_keluarga.splice(index, 1);  
        this.$store.commit('notif_berhasil_menghapus');        
      },
      select_keluarga(data, index){

        // console.log(data, index) 
        this.id = data._id
        this.index_ke = index 
      },
      delete_keluarga2(data, index){
        this.$store.state.modal_loading = true;


        console.log(this.index_ke) 
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "hapus_keluarga", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.id,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.list_anggota_keluarga.splice(this.index_ke, 1); 
            this.$store.state.modal_loading = false;
            this.modal_hapus_keluarga = false
            this.$store.commit('notif_berhasil_menghapus'); 
            this.getView();
        });
      },
      EditAnggotaKeluarga(){
        this.$store.state.modal_loading = true;

          var a = this.form.KKref  
          this.anggota_keluarga.KKref = a 
          console.log('aaaaa = ', a);

          var formData = new FormData(); 
          formData.append("biodata", JSON.stringify(this.anggota_keluarga));

          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNI + "editData_AK", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => { 
          this.$store.state.modal_loading = false;


              this.$store.commit('notif_edit');
              var arr = this.list_anggota_keluarga; 
              arr.push(this.anggota_keluarga);
              
              this.anggota_keluarga = {
                nik : '',
                nama : '',
                tanggal_lahir : '',
                jenis_kelamin : '',
                shdk:'',
                shdk_lainnya:'',
                agama : '',
                agama_lainnya : '',
                pekerjaan : '',
                pekerjaan_lainnya : '',
                pendidikan : '',
                pendidikan_lainnya : '',
              }

              this.getView();
          }); 
      },

      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;  
                this.page_last = res_data.jmlData;   
                console.log(this.list_data);
        });
      },
      addData:function(){
        this.$store.state.modal_loading = true;

          console.log(this.form);
          var formData = new FormData();

          formData.append("data", JSON.stringify(this.form));
          formData.append("biodata", JSON.stringify(this.list_anggota_keluarga)); 
          formData.append("file",           this.form.file); 
          formData.append("file_lampiran",  this.form.file_lampiran); 
            fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "addData1", {
                method: "POST",
                headers: {
                    // "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            }).then(res_data => { 
          this.$store.state.modal_loading = false;

                this.$store.commit('notif_berhasil')
                this.getView();
            });
      },
      editData:function(){
        this.$store.state.modal_loading = true;

        // console.log('ini form = ', this.form);
        // console.log('ini list = ', this.list_anggota_keluarga);
        // URL_PERMOHONAN_KK_WNA
        var formData = new FormData();
        formData.append("data", JSON.stringify(this.form));
        formData.append("biodata", JSON.stringify(this.list_anggota_keluarga));
        formData.append("file",           this.form.file);
        formData.append("file_lampiran",  this.form.file_lampiran);

        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => {
            // console.log(res_data); 
            this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getView();
        });

      }, 
      removeData:function(){ 
        this.$store.state.modal_loading = true;

        fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                KKref : this.form.KKref,
                fileOld : this.fileOld,
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        });     
      }, 
      selectData:function(data){

        console.log(data);
        
        this.form.id = data.KK3.id
        this.form.KKref = data.KK3.KKref
        this.form.id_dari_form = data.KK3.id_dari_form

        this.form.m_provinsi = data.KK3.m_provinsi
        this.form.m_kabupaten = data.KK3.m_kabupaten
        this.form.m_kecamatan = data.KK3.m_kecamatan
        this.form.m_desa_kelurahan = data.KK3.m_desa_kelurahan

        this.form.permohonan = data.KK3.permohonan
        this.form.permohonan_lainnya = data.KK3.keterangan_lainnya
        this.form.nama = data.KK3.nama
        this.form.nik = data.KK3.nik
        this.form.no_kk = data.KK3.no_kk

        this.form.shdk = data.KK3.shdk
        this.form.shdk_lainnya = data.KK3.shdk_lainnya
        this.form.agama = data.KK3.agama
        this.form.agama_lainnya = data.KK3.agama_lainnya
        this.form.pekerjaan = data.KK3.pekerjaan
        this.form.pekerjaan_lainnya = data.KK3.pekerjaan_lainnya
        this.form.pendidikan = data.KK3.pendidikan 
        this.form.pendidikan_lainnya = data.KK3.pendidikan_lainnya 

        this.form.alamat = data.KK3.alamat
        this.form.rt = data.KK3.rt
        this.form.rw = data.KK3.rw
        this.form.kode_pos = data.KK3.kode_pos
        this.form.Telepon = data.KK3.Telepon
        this.form.no_kitap = data.KK3.no_kitap
        this.form.tgl_berakhir_kitap = data.KK3.tgl_berakhir_kitap

        this.form.provinsi = data.KK3.provinsi
        this.form.kabupaten = data.KK3.kabupaten
        this.form.kecamatan = data.KK3.kecamatan  
        this.form.desa_kelurahan = data.KK3.desa_kelurahan

        this.form.file_Kabupaten = data.KK3.file_Kabupaten
        this.form.file_Old_Kabupaten = data.KK3.file_Old_Kabupaten


        this.form.status = data.KK3.status
        this.form.keterangan = data.KK3.keterangan
        this.form.keterangan_deskel = data.KK3.keterangan_deskel
        this.form.keterangan_kecamatan = data.KK3.keterangan_kecamatan
        this.form.keterangan_kabupaten = data.KK3.keterangan_kabupaten
        this.form.status_deskel = data.KK3.status_deskel
        this.form.status_kecamatan = data.KK3.status_kecamatan
        this.form.status_kabupaten = data.KK3.status_kabupaten
        this.form.createdBy = data.KK3.createdBy
        this.form.createdAt = data.KK3.createdAt
        this.form.createdAt_deskel = data.KK3.createdAt_deskel
        this.form.createdAt_kecamatan = data.KK3.createdAt_kecamatan
        this.form.createdAt_kabupaten = data.KK3.createdAt_kabupaten

        this.list_anggota_keluarga = data.databio

        this.form.emailPemohon          = data.KK3.emailPemohon;
        this.form.email_fileOld         = data.KK3.email_file;
        this.form.email_from            = this.form.email_from;
        this.form.email_to              = this.form.emailPemohon;
        this.form.email_subject         = data.KK3.email_subject;
        if (data.KK3.email_html == undefined || data.KK3.email_html == null || data.KK3.email_html == '') {
          this.form.email_html          = ''
        } else {
          this.form.email_html          = data.KK3.email_html; 
        }
        this.form.file                  = data.KK3.file
        this.form.fileThumb             = data.KK3.fileThumb
        this.form.file_lampiran         = data.KK3.file_lampiran
        this.form.file_lampiranOld      = data.KK3.file_lampiranOld

        this.wilayah = {
          uraian_provinsi : data.m_provinsi.uraian,
          kd_provinsi : data.m_provinsi.kd_provinsi,
          uraian_kabupaten : data.m_kabupaten.uraian,
          kd_kabupaten : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.m_kecamatan.uraian,
          kd_kecamatan : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
        }
 
        this.wilayah_pemohon = {
          uraian_provinsi : data.provinsi.uraian,
          kd_provinsi : data.provinsi.kd_provinsi,
          uraian_kabupaten : data.kabupaten.uraian,
          kd_kabupaten : data.kabupaten.kd_kabupaten,
          uraian_kecamatan : data.kecamatan.uraian,
          kd_kecamatan : data.kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.desa_kelurahan.uraian,
          kd_desa_kelurahan : data.desa_kelurahan.kd_desa_kelurahan,
        }
      },
      clear_data:function(data){
          this.form.id                              = ''
          this.form.KKref                           = ''
          this.form.id_dari_form                    = ''
          this.form.m_provinsi                      = '74'
          this.form.m_kabupaten                     = '7405'
          this.form.m_kecamatan                     = ''
          this.form.m_desa_kelurahan                = ''
          this.form.permohonan                      = ''
          this.form.permohonan_lainnya              = ''
          this.form.nama                            = ''
          this.form.nik                             = ''
          this.form.no_kk                           = ''
          this.form.shdk                            = ''
          this.form.shdk_lainnya                    = ''
          this.form.agama                           = ''
          this.form.agama_lainnya                   = ''
          this.form.pekerjaan                       = ''
          this.form.pekerjaan_lainnya               = ''
          this.form.pendidikan                      = ''
          this.form.pendidikan_lainnya              = ''
          this.form.alamat                          = ''
          this.form.rt                              = ''
          this.form.rw                              = ''
          this.form.kode_pos                        = ''
          this.form.Telepon                         = ''
          this.form.no_kitap                        = ''
          this.form.tgl_berakhir_kitap              = ''
          this.form.provinsi                        = ''
          this.form.kabupaten                       = ''
          this.form.kecamatan                       = ''
          this.form.desa_kelurahan                  = ''
          this.form.file_Kabupaten                  = null
          this.form.file_Old_Kabupaten              = null
          this.form.status                          =  0
          this.form.keterangan                      =  0
          this.form.keterangan_deskel               = ''
          this.form.keterangan_kecamatan            = ''
          this.form.keterangan_kabupaten            = ''
          this.form.status_deskel                   = 0
          this.form.status_kecamatan                = 0
          this.form.status_kabupaten                = 0
          this.form.createdAt                       =  ''
          this.form.createdAt_deskel                = ''
          this.form.createdAt_kecamatan             = ''
          this.form.createdAt_kabupaten             = ''
          this.form.file_lampiran                   = null
          this.form.file_lampiranOld                = null
          this.form.file_terbitan                   =  null
          this.form.emailPemohon                    =  ''
          this.form.email_file                      =  null
          this.form.email_fileOld                   =  ''
          this.form.email_from                      =  ''
          this.form.email_to                        =  ''
          this.form.email_subject                   =  ''
          this.form.email_html                      =  ''
          this.list_anggota_keluarga                = []
          this.anggota_keluarga.nik                 = ''
          this.anggota_keluarga.nama                = ''
          this.anggota_keluarga.tanggal_lahir       = ''
          this.anggota_keluarga.jenis_kelamin       = ''
          this.anggota_keluarga.shdk                = ''
          this.anggota_keluarga.shdk_lainnya        = ''
          this.anggota_keluarga.agama               = ''
          this.anggota_keluarga.agama_lainnya       = ''
          this.anggota_keluarga.pekerjaan           = ''
          this.anggota_keluarga.pekerjaan_lainnya   = ''
          this.anggota_keluarga.pendidikan          = ''
          this.anggota_keluarga.pendidikan_lainnya  = ''
        // this.form = ''
        // this.list_anggota_keluarga = ''

         
      },

      // ============================= KECAMATAN =============================
        getViewKecamatan : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "viewKecamatan", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kecamatan : this.form.status_kecamatan,
                  pl_provinsi       :this.$store.state.lcProfile.provinsi,
                  pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                  pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
              })
            })
              .then(res => res.json())
              .then(res_data => { 
                  this.list_data_kecamatan = res_data.data;
                  this.page_last = res_data.jmlData; 
                  // console.log("INI KECAMATAN")
                  console.log(res_data);
          });
        },


        editDataKecamatan : function(status){
          this.$store.state.modal_loading = true;

          // console.log(status)
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "editDataKecamatan", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kecamatan : this.form.keterangan_kecamatan,
                createdAt_kecamatan : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              this.getViewKecamatan();
          });
        },

      // ============================= KECAMATAN =============================

      // ============================= KABUPATEN =============================
        getViewKabupaten : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "viewKabupaten", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kabupaten : this.form.status_kabupaten
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kabupaten = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log(res_data);
          });
        },
        editDataKabupaten : function(status){
          this.$store.state.modal_loading = true;

          console.log("SA DI CLICK")
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "editDataKabupaten", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kabupaten : this.form.keterangan_kabupaten,
                createdAt_kabupaten : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;

              this.$store.commit('notif_edit');
              this.getViewKabupaten();
          });
        },
        terbit_file_Kabupaten : function(){
          this.$store.state.modal_loading = true;

          console.log(this.form.email_fileOld);
          var formData = new FormData();
          formData.append("id", this.form.id);
          formData.append("email_file", this.form.email_file); 
          formData.append("email_fileOld", this.form.email_fileOld); 
          formData.append("email_from", this.form.email_from)
          formData.append("email_to", this.form.email_to)
          formData.append("email_subject", this.form.email_subject) 
          formData.append("email_html", this.form.email_html)
          
          fetch(this.$store.state.url.URL_PERMOHONAN_KK_WNA + "file_terbitan_Kabupaten", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData,
          }).then(res_data => { 
              this.wa_notif()
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_terbit');
              this.getView();
          });
        },
        async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Permohonan Kartu Keluarga (KK) Baru Orang Asing Yang Memiliki Izin Tinggal Tetap'
          }))
          console.log(data);
        },
      // ============================= KABUPATEN =============================
      bukaTab(linknya){
        window.open(linknya);
      },
    // ====================================== filter autocomplete  
      renderChildProv(data) {
          return `
          <span><b>${data.kd_provinsi}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKab(data) {
          return `
          <span><b>${data.kd_kabupaten}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChildKec(data) {
          return `
          <span><b>${data.kd_kecamatan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    
      renderChild_des_kel(data) {
          return `
          <span><b>${data.kd_desa_kelurahan}</b></span>
          <span style='font-size:80%'>${data.uraian}</span>
          `
      },    

      get_auto(data){
        this.form.m_provinsi = data.m_provinsi   
        // console.log(data.kd_provinsi); 
      },        
      get_auto_kab(data){ 
        this.form.m_kabupaten = data.m_kabupaten  
        // console.log(data.kd_kabupaten); 
      },        
      get_auto_kec(data){ 
        this.form.m_kecamatan = data.m_kecamatan  
        // console.log(data.kd_kecamatan); 
      },        
      get_auto_des_kel(data){ 
        this.form.m_desa_kelurahan = data.m_desa_kelurahan  
        // console.log(data.kd_desa_kelurahan); 
      },  

      // ==== daerah ================ 
        get_prov(data){ 
          this.form.provinsi = data.m_provinsi   
        },        
        get_kab(data){ 
          this.form.kabupaten = data.m_kabupaten   
        },        
        get_kec(data){ 
          this.form.kecamatan = data.m_kecamatan   
        },        
        get_des_kel(data){ 
          this.form.desa_kelurahan = data.m_desa_kelurahan   
        },        
      // ==== daerah ================   

    // ====================================== filter autocomplete 
      CariData(){
        
        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },
      cekButton_status_kecamatan: function(data){  
        var a = data.KK3.status 
        var status_kab = data.KK3.status_kabupaten  
        if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
          if (status_kab == 1) {
            return true
          }
          return false
        }else{
          if (a == 1) {
            return true
          }else{
            return false
          }
        }  
      },

    },

    mounted(){
      this.list_anggota_keluarga = []
      this.CariData();
      // this.getView();
      this.MASTER_MENU.agama();
      this.MASTER_MENU.pekerjaan();
      this.MASTER_MENU.pendidikan(); 
      this.MASTER_MENU.shdk();

      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      this.form.emailPemohon  = email_pemohon
      this.form.email_from    = email_from 
    }
}
